export function specificationSheet() {
    const cards = $(".specification-sheet-card");
    const cardButtons = cards.find(".btn");
    const cardActive = $(".specification-sheet-card.active").data("row");
    const allDataRow = $("[data-row]");
    const setActive = ( allDataRow, dataActive ) => {
        allDataRow.each((index, item) => {
            if ($(item).data("row").includes(dataActive)) {
                $(item).addClass("active");
            }
        });
    };
    const removeActive = (allDataRow) => {
        allDataRow.removeClass("active");
    };

    cardButtons.on("click", function (e) {
        e.preventDefault();
        const currentActive = $(this).closest(".specification-sheet-card").data("row");
        const allDataRow = $(this).closest(".specification-sheet-section").find("[data-row]");
        removeActive(allDataRow);
        setActive(allDataRow, currentActive);
    });


    cards.hover(function (e){
        const currentActive = $(this).closest(".specification-sheet-card").data("row");
        const allDataRow = $(this).closest(".specification-sheet-section").find("[data-row]");
        removeActive(allDataRow);
        setActive(allDataRow, currentActive);
    });

    setActive(allDataRow, cardActive);
}


// WEBPACK FOOTER //
// ./assets/js/modules/specificationSheet.js